import { Routes } from '@angular/router';
// import { Layout } from './shared/components/layout/layout';
// import { ActivateAccount } from './Pages/auth/activate-account/activate-account'
import { AuthContainer } from '@auth/auth-container/auth-container';
import { Register } from '@auth/register/register';
import { Login } from '@auth/login/login';
import { VendorActivation } from '@auth/vendor-activation/vendor-activation';
import { SideBar } from './Pages/shared/layouts/side-bar/side-bar';
import { authGuard } from './core/guard/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },

  {
    path: 'login',
    loadComponent: () => import('./Pages/auth/login/login').then((m) => m.Login),
  },

  {
    path: '',
    component: SideBar,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./Pages/Main/dashboard/dashboard').then((m) => m.Dashboard),
      },

      {
        path: 'orders',
        loadComponent: () => import('./Pages/Main/orders/orders').then((m) => m.Orders),
      },

      {
        path: 'payouts',
        loadComponent: () => import('./Pages/Main/payouts/payouts').then((m) => m.Payouts),
      },
      {
        // Revenue → View Details: one month's payments
        path: 'payouts/:year/:month',
        loadComponent: () =>
          import('./Pages/Main/payouts/payout-details/payout-details').then((m) => m.PayoutDetails),
      },

      {
        path: 'transactions',
        loadComponent: () =>
          import('./Pages/Main/transactions/transactions').then((m) => m.Transactions),
      },

      {
        path: 'settings',
        loadComponent: () => import('./Pages/Main/settings/settings').then((m) => m.Settings),
      },

      {
        path: 'support',
        loadComponent: () => import('./Pages/Main/support/support').then((m) => m.Support),
      },
      {
        path: 'menu',
        loadComponent: () => import('./Pages/Main/menu/menu').then((m) => m.Menu),
      },
      {
        path: 'ratings',
        loadComponent: () => import('./Pages/Main/rating/rating').then((m) => m.Rating),
      },
      {
        path: 'staff-member',
        loadComponent: () =>
          import('./Pages/Main/staff-member/staff-member').then((m) => m.StaffMemberPage),
      },
      {
        path: 'rating',
        redirectTo: 'ratings',
        pathMatch: 'full',
      },
    ],
  },

  {
    path: '',
    component: AuthContainer,
    children: [
      {
        path: 'register',
        loadComponent: () => import('@auth/register/register').then((m) => m.Register),
      },
      // {
      //   path: 'set-password',
      //   loadComponent: () =>
      //     import('@auth/activate-account/activate-account').then((m) => m.ActivateAccount),
      // },

      {
        path: 'vendor-activation',
        loadComponent: () =>
          import('@auth/activate-account/activate-account').then((m) => m.ActivateAccount),
      }
    ],
  },

  {
    path: 'auth',
    loadChildren: () => import('./Pages/auth/auth.routes').then((m) => m.routes),
  },

  {
    path: 'account/activate',
    loadComponent: () =>
      import('@auth/activate-account/activate-account').then((m) => m.ActivateAccount),
  },

  {
    path: 'account/reset-password',
    loadComponent: () =>
      import('@auth/reset-password/reset-password').then((m) => m.ResetPassword)

  },

  {
    path: '**',
    redirectTo: 'login',
    pathMatch: 'full',
  },
] as Routes;
